import React from 'react'
import {
  Dashboard as DashboardIcon,
  Home as HomeIcon,
  Engineering as EngineeringIcon,
  Assignment as AssignmentIcon,
  Checklist as ChecklistIcon,
  Build as BuildIcon,
  Inventory as InventoryIcon,
  Assessment as AssessmentIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
  People as PeopleIcon,
  Business as BusinessIcon,
  AccountTree as AccountTreeIcon,
  Security as SecurityIcon,
  Settings as SettingsIcon,
  Info as InfoIcon,
  PhotoLibrary as PhotoLibraryIcon,
} from '@mui/icons-material'

export interface NavItem {
  id: string
  labelKey: string // Translation key instead of direct label
  path: string
  icon: React.ReactElement
  badge?: number | string
  permission?: string
}

export interface NavGroup {
  id: string
  labelKey: string // Translation key instead of direct label
  icon: React.ReactElement
  items: NavItem[]
  defaultExpanded?: boolean
}

export const navigationConfig: NavGroup[] = [
  {
    id: 'overview',
    labelKey: 'sidebar.overview',
    icon: React.createElement(DashboardIcon),
    items: [
      {
        id: 'dashboard',
        labelKey: 'navigation.dashboard',
        path: '/dashboard',
        icon: React.createElement(HomeIcon),
      },
    ],
    defaultExpanded: true,
  },
  {
    id: 'operations',
    labelKey: 'sidebar.operations',
    icon: React.createElement(BuildIcon),
    items: [
      {
        id: 'equipment',
        labelKey: 'navigation.equipment',
        path: '/equipment',
        icon: React.createElement(EngineeringIcon),
      },
      {
        id: 'inspections',
        labelKey: 'navigation.inspections',
        path: '/inspections',
        icon: React.createElement(AssignmentIcon),
      },
      {
        id: 'maintenance',
        labelKey: 'navigation.maintenance',
        path: '/maintenance',
        icon: React.createElement(BuildIcon),
      },
      {
        id: 'media-library',
        labelKey: 'navigation.mediaLibrary',
        path: '/media',
        icon: React.createElement(PhotoLibraryIcon),
      },
    ],
  },
  {
    id: 'checklists',
    labelKey: 'sidebar.checklists',
    icon: React.createElement(ChecklistIcon),
    items: [
      {
        id: 'checklist-manage',
        labelKey: 'sidebar.checklistManage',
        path: '/inspections/checklists',
        icon: React.createElement(ChecklistIcon),
      },
      {
        id: 'checklist-analytics',
        labelKey: 'sidebar.checklistAnalytics',
        path: '/checklists/analytics',
        icon: React.createElement(AssessmentIcon),
      },
      {
        id: 'checklist-responses',
        labelKey: 'sidebar.checklistResponses',
        path: '/checklists/responses',
        icon: React.createElement(AssignmentIcon),
      },
    ],
  },
  {
    id: 'inventory',
    labelKey: 'sidebar.inventoryGroup',
    icon: React.createElement(InventoryIcon),
    items: [
      {
        id: 'inventory',
        labelKey: 'sidebar.stock',
        path: '/inventory',
        icon: React.createElement(InventoryIcon),
      },
    ],
  },
  {
    id: 'analytics',
    labelKey: 'sidebar.analytics',
    icon: React.createElement(AssessmentIcon),
    items: [
      {
        id: 'reports',
        labelKey: 'navigation.reports',
        path: '/reports',
        icon: React.createElement(AssessmentIcon),
      },
    ],
  },
  {
    id: 'admin',
    labelKey: 'sidebar.administration',
    icon: React.createElement(AdminPanelSettingsIcon),
    items: [
      {
        id: 'users',
        labelKey: 'navigation.users',
        path: '/users',
        icon: React.createElement(PeopleIcon),
        permission: 'users:read',
      },
      {
        id: 'departments',
        labelKey: 'sidebar.departments',
        path: '/departments',
        icon: React.createElement(AccountTreeIcon),
      },
      {
        id: 'permissions',
        labelKey: 'sidebar.myPermissions',
        path: '/my-permissions',
        icon: React.createElement(SecurityIcon),
      },
      {
        id: 'settings',
        labelKey: 'navigation.settings',
        path: '/settings',
        icon: React.createElement(SettingsIcon),
      },
      {
        id: 'about',
        labelKey: 'about.title',
        path: '/about',
        icon: React.createElement(InfoIcon),
      },
    ],
  },
]
